<template>
  <div id="app" class="container-fluid p-l-r-0 login " :class="bgClass">
    <Header></Header>
    <notifications group="auth" position="bottom right" />
    <router-view/>
    <!-- <Hfooter/> -->
  </div>
</template>
<script>
import Header from './views/layouts/header'
// import Hfooter from './views/layouts/HomeFooter'
// import HomeFooter from './views/layouts/HomeFooter'
export default {
  data(){
    return {
      bgClass:''
    }
  },
 components:{
   Header,
  //  Hfooter
 },
 created: function () {
   this.bgClass= this.$route.name== 'Login' ? 'banner-bg' :'';
},
mounted(){
}
};
</script>
<style scoped>
#app {
  font-family: 'Lato', sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
@import './assets/css/bootstrap.min.css';
@import './assets/css/header-footer.css';
</style>
